import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Invite from "@/pages/Invite";
import Dashboard from "@/pages/Dashboard";
import Enrollments from "@/pages/Enrollments";
import NewAudit from "@/pages/NewAudit";
import SiteDetail from "@/pages/SiteDetail";
import Settings from "@/pages/Settings";
import AddOns from "@/pages/AddOns";
import GoLive from "@/pages/GoLive";
import ReviewLanding from "@/pages/ReviewLanding";
import { StepUpGate } from "@/components/StepUpGate";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        <Loader2 className="mr-2 h-5 w-5 animate-spin" /> Loading…
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <StepUpGate />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/invite/:token" element={<Invite />} />
            <Route path="/r/:token" element={<ReviewLanding />} />
            <Route path="/review/:token" element={<ReviewLanding kind="site" />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/enrollments" element={<Protected><Enrollments /></Protected>} />
            <Route path="/new" element={<Protected><NewAudit /></Protected>} />
            <Route path="/site/:id" element={<Protected><SiteDetail /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/addons" element={<Protected><AddOns /></Protected>} />
            <Route path="/golive" element={<Protected><GoLive /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
